<template>
	<CDialog
		class="cog-referral-branding-dialog"
		:visible="showDialog"
		title="Include Branding?"
		custom-class="dialog--narrow"
		@close="handleClose"
	>
		<div>
			<p>As a paid customer, our branding is removed from your forms, but you can add it back in order to start earning referrals from your users that click our link at the bottom of your forms and sign up.</p>
		</div>
	</CDialog>
</template>

<script lang="ts">
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'CReferralBrandingDialog',
		components: {
			CDialog
		},
		props: {
			showDialog: {
				type: Boolean,
				required: true
			}
		},
		methods: {
			handleClose() {
				this.$emit('close');
			}
		}
	});
</script>